import { createSlice } from '@reduxjs/toolkit';

const projectSlice = createSlice({
    name: 'project',
    initialState: {
        project: [
            {
                id: 1,
                foto: 'projectOne.png',
                title: 'Winery Dry Creek Building',
                category: 'Art Modern',
            },
            {
                id: 2,
                foto: 'Furniture.png',
                title: 'Creative Workplace Design',
                category: 'Minimalist',
            },
            {
                id: 3,
                foto: 'Bedroom.png',
                title: 'Bedroom Interior Pot Work',
                category: 'Modern',
            },
            {
                id: 4,
                foto: 'Design.png',
                title: 'Light Ambience Sepia Design',
                category: 'Scandinavian',
            }
        ],
    },
    reducers: {
    },
});

export default projectSlice.reducer;